import { Injectable } from "@angular/core";
import { DepositPaymentMetricProperties } from "@backend/common/analytics/metrics";
import { AnalyticsService, METRIC } from "../analytics.service";
import { JWTService } from "../jwt.service";
import { PersistentObjectFactory } from "../../utils/persistent-object";
import { CacheService } from "../cache.service";

@Injectable({
  providedIn: "root",
})
export class DepositPaymentsMetricsService {
  private _properties: DepositPaymentMetricProperties;
  private _persistentObjectFactory: PersistentObjectFactory;

  constructor(private _jwtService: JWTService, private _analyticsService: AnalyticsService, cacheService: CacheService) {
    this._persistentObjectFactory = new PersistentObjectFactory(cacheService, "deposit-payment-metric-properties");
    this._properties = this._persistentObjectFactory.create(new DepositPaymentMetricProperties());
  }

  public trackDepositPaymentOpened(amount: number): void {
    try {
      this._properties.referrer = this._jwtService.getJWT().referrer;
      this._properties.amount = amount;
      this._analyticsService.track(new METRIC.ActionOpened_DepositPayment(this._properties.referrer, this._properties.amount));
    } catch (e) {
      console.error("error tracking payment opened metric", e);
    }
  }

  public trackDepositPaymentDone(siteId: string, paymentMethod?: string | undefined): void {
    try {
      this._properties.referrer = this._jwtService.getJWT().referrer;
      this._properties.payment_method = paymentMethod;
      this._analyticsService.track(
        new METRIC.ActionDone_DepositPayment(siteId, this._properties.referrer, this._properties.amount, this._properties.payment_method)
      );
      this._persistentObjectFactory.clear(this._properties);
    } catch (e) {
      console.error("error tracking payment done metric", e);
    }
  }
}
